import React from 'react';
import Component from 'components/Grid';
import {connect} from 'react-redux';
import {setWorkDimensions} from 'actions/WorksActions';
import {allWorks, currentId} from 'selectors/worksSelectors';
import {Id, Work, Dimension} from 'types/Work';
import {
	RouteComponentProps,
	RouteProps
} from 'react-router-dom';
import { Route } from 'react-router';
import { Location } from 'types/Nav';
import withRouter from 'utils/withRouter';

interface GridProps extends RouteComponentProps{
	works: Work[];
	id: Id;
	router: any;
}

const mapStateToProps = (state, ownProps): GridProps => ({
	router: state.router,
	works: allWorks(state),
	id: currentId(state),
})

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		navigateTo: (location: Location): void => {
			if (ownProps.navigate) {
				ownProps.navigate(location);
			}
		},
		setWorkDimensions: (id: Id, dimensions: Dimension): void => {
			dispatch(setWorkDimensions(id, dimensions));
		}
	};
}

const Container = withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(Component));
export default Container;